// import exactMath from "exact-math";
import { ethers } from 'ethers';
import ResponseService from './response.service';

let privateProvider = null;
let signer = null;

const isMetaMaskInstalled = () => {
  //Have to check the ethereum binding on the window object to see if it's installed
  const { ethereum } = window;
  if (!(ethereum && ethereum.isMetaMask)) {
    return ResponseService.buildFailure(
      'Metamask is not installed, Please install metamask to connect the wallet.',
    );
  }
  return ResponseService.buildSuccess('Metamask is installed.');
};

const getBlockchainProvider = async (_isPublic) => {
  try {
    let isPublic = _isPublic ? _isPublic : false;
    if (isPublic === false) {
      let metamaskResp = isMetaMaskInstalled();
      //Created check function to see if the MetaMask extension is installed
      if (metamaskResp.status === 'failure') {
        return metamaskResp;
      }

      privateProvider = new ethers.BrowserProvider(window.ethereum);

      signer = await privateProvider.getSigner();
    }
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const connectWallet = async () => {
  try {
    let metamaskResp = isMetaMaskInstalled();

    //Created check function to see if the MetaMask extension is installed
    if (metamaskResp.status === 'failure') {
      return metamaskResp;
    }

    /*----------------------------------------------------------------
    |call to metamask 
    ----------------------------------------------------------------*/

    privateProvider = new ethers.BrowserProvider(window.ethereum);

    signer = await privateProvider.getSigner();
    /*----------------------------------------------------------------
    |call to metamask 
    ----------------------------------------------------------------*/

    await privateProvider.send('eth_requestAccounts', []);

    /* ----------------------------------------------------------------
    | Get wallet address from connected metamask account
    ---------------------------------------------------------------- */
    const walletAddress = await signer.getAddress();
    const getBalance = await privateProvider.getBalance(walletAddress);
    const Balance = await formatEtherDecimals(getBalance);
    return ResponseService.buildSuccess('Connection established', {
      walletAddress: walletAddress,
      balance: Balance,
    });
  } catch (error) {
    if (error?.error?.code === -32002) {
      return ResponseService.buildFailure(
        'You have already initiated a request for connection, please select on the metamask extension to proceed further.',
      );
    } else if (error?.info?.error?.code === 4001) {
      return ResponseService.buildFailure(
        'You rejected the metamask connection request.',
      );
    } else {
      return ResponseService.buildFailure(error.message);
    }
  }
};

/**
 * This function normally formats the amount from 18 decimals, However, since we have
 * change the decimals to 0, we are returning the same amount.
 *
 * @param amount
 * @returns amount
 *
 */
const formatEtherDecimals = async (_amount) => {
  return _amount;
};

const networkDetails = async () => {
  try {
    /* ----------------------------------------------------------------
    | Get Wallet balance and address from connected metamask account
    ---------------------------------------------------------------- */

    if (privateProvider == null) {
      const _error = {
        code: 'PROVIDER_UNAVAILABLE',
      };
      return ResponseService.buildFailure('Provider is unavailable', _error);
    }

    const _networkInfo = await privateProvider.getNetwork();

    return ResponseService.buildSuccess(
      'Network details fetched successfully',
      _networkInfo,
    );
  } catch (error) {
    if (error.code === 'NETWORK_ERROR') {
      const _error = {
        code: error.code,
      };
      return ResponseService.buildFailure(error.message, _error);
    }
    return ResponseService.buildFailure(error.message);
  }
};

const BlockchainService = {
  isMetaMaskInstalled,
  formatEtherDecimals,
  networkDetails,
  connectWallet,
  getBlockchainProvider,
};

export default BlockchainService;
